<template>
  <div class="order_form_point">
    <div class="form-ctn">
      <put-scheme v-if="!isSmallSn" ref="chargeWayRef" @change="changeChargeWay"></put-scheme>
      <el-form size="mini" :model="order">
        <el-form-item class="must" label="投放城市">
          <MultCityAsync ref="cityChoose" @change="getAddressCodes" />
        </el-form-item>
        <el-form-item class="must" label="投放日期">
          <el-date-picker
            v-if="chargeWayName == 'cpmL'"
            type="date"
            class="input-date"
            :clearable="false"
            placeholder="选择开始日期"
            :picker-options="startPickerOptions"
            value-format="yyyy-MM-dd"
            v-model="order.startDate"
            @change="startDateChange">
          </el-date-picker>
          <template v-else>
            <el-date-picker
              type="date"
              class="input-date"
              :clearable="false"
              placeholder="选择开始日期"
              :picker-options="startPickerOptions"
              value-format="yyyy-MM-dd"
              v-model="order.startDate"
              @change="startDateChange">
            </el-date-picker>
            <span style="font-size: 12px;">至</span>
            <el-date-picker
              type="date"
              class="input-date"
              :clearable="false"
              placeholder="选择结束日期"
              :picker-options="endPickerOptions"
              value-format="yyyy-MM-dd"
              v-model="order.endDate"
              @change="endDateChange">
            </el-date-picker>
          </template>
          <i class="iconfont icon-biaodan-shijian fr"></i>
        </el-form-item>
        <el-form-item class="must" label="投放时段">
          <el-popover placement="bottom" trigger="click" popper-class="time-slot" @show="showTime = !showTime" @hide="showTime = !showTime">
            <div slot="reference" class="time-area">
              <span class="fl els">{{ timeStr }}</span>
              <i class="fr el-icon-arrow-down" :class="{'up': showTime}"></i>
            </div>
            <SearchTimeRange ref="timeRangeRef" :isInit="true" @submit="timeConfirm" />
          </el-popover>
        </el-form-item>
        <el-form-item class="must" label="单次曝光">
          <el-select placeholder="选择单次曝光" popper-class="form_pop" v-model="order.contentTime">
            <el-option v-for="t in contentTimes" :key="t.dictItemName" :label="t.dictItemName+'秒'" :value="t.dictItemName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <TargetLabelFlow v-if="chargeWayName.indexOf('cpm') > -1" :mode="chargeWayName" v-model="order.targetFlowData"></TargetLabelFlow>
      <!-- <el-form v-if="chargeWayName == 'rtb'" size="mini" :model="order">
        <el-form-item class="must" label="合同单价">
          <el-input size="mini" placeholder="请输入" v-model="order.unitPrice" @keyup.native="handleChange">
            <i slot="append">元/千人次</i>
          </el-input>
        </el-form-item>
      </el-form> -->

      <el-form v-if="chargeWayName != 'pkg'" size="mini" :model="order">
        <el-form-item class="must custom" label="合同编码">
          <el-input placeholder="请输入正确的合同编码" :maxlength="30" v-model="order.contractNo">
            <i slot="suffix" class="iconfont icon-biaodan-tianxie"></i>
          </el-input>
        </el-form-item>
        <!-- 小屏投放不加【展现位置】 -->
        <!-- <el-form-item v-if="!isSmallSn" class="must" label="展现位置">
          <el-select placeholder="选择展现位置" popper-class="form_pop" v-model="order.displayRegion">
            <el-option v-for="reg in displayRegions" :key="reg.value" :label="reg.label" :value="reg.value"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <el-form size="mini" style="width:100%" :model="order">
        <!--新禁播标签-->
        <el-form-item label="禁播标签">
          <!--          <el-select placeholder="选择禁播标签" popper-class="form_pop" v-model="order.noPlayingLabels" multiple>-->
          <!--            <el-option v-for="item in noPlayingLabels" :key="item.dictItemCode" :label="item.dictItemName" :value="item.dictItemName" ></el-option>-->
          <!--          </el-select>-->
          <NoPlayingLabelSelector  v-model="order.noPlayingLabels"></NoPlayingLabelSelector>
        </el-form-item>
      </el-form>
      <LabelCmp ref="labelCmp" @change="labelDataChange"></LabelCmp>
    </div>
    <div class="btm">
      <div class="btn search" @click="searchAction">筛选点位</div>
      <div class="btn" @click="reset">重置条件</div>
    </div>
  </div>
</template>

<script>
import PointSelect from './OrderForm/Select'
import PointSelectSpe from './OrderForm/SelectSpe'
import Special from './OrderForm/Special'
import PutScheme from '@/views/PutOrder/components/OrderForm/PutScheme'
import CustomUser from '@/views/PutOrder/components/OrderForm/CustomUser'
import LabelCmp from '@/views/PutOrder/components/OrderForm/LabelCmp.vue'
import TargetLabelFlow from './OrderForm/TargetLabelFlow'
import SearchTimeRange from '@/components/SearchTimeRange'

import { ChargeWayEnum } from '@/views/PutOrder/config.js'
import searchPointMix from '@/utils/mixins/searchPointMix'
import NoPlayingLabelSelector from "@/components/NoPlayingLabelSelector";

const dayMs = 24 * 3600000
const dateNow = new Date()

export default {
  name: 'OrderFormPoint',
  components: {NoPlayingLabelSelector, Special, PointSelect, PointSelectSpe, TargetLabelFlow, LabelCmp, PutScheme, SearchTimeRange, CustomUser },
  mixins: [ searchPointMix ],
  data () {
    let vm = this
    return {
      timtRange: 0,
      chargeWayName: '',
      labelParam: {},
      commonLabelData: [],
      labelListPayway: [],
      order: {
        startDate: new Date(+dateNow + 2 * dayMs).format().slice(0, 10),
        endDate: new Date(+dateNow + 8 * dayMs).format().slice(0, 10),
        targetFlowData: { targetFlowOrbudgetAmount: '', chooseLabel: [] },
        packageInfoCodes: [], personsLabels: [], industryCodes: [],
        contractNo: '',
        displayRegion: 1,
        noPlayingLabels:[],
      },
      startPickerOptions: {
        disabledDate (t) {
          const dt = new Date(t)
          return dt - dateNow < -dayMs || dt - dateNow > 92 * dayMs
        }
      },
      endPickerOptions: {
        disabledDate (d) {
          const dt = new Date(d)
          const theStart = new Date(vm.order.startDate)
          return dt - theStart - 92 * dayMs > 0 || dt - theStart < -dayMs || dt - dateNow > 92 * dayMs
        }
      },
      contentTimes: [],
      timeStr: '',
      searchTimeRange: [], // 投放时段
      showTime: false
    }
  },
  computed: {
    isSmallSn () { // 是否是小屏投放或小屏导入点位
      let name = this.$store.state.order.conditionSearchTypeName
      return name.toLowerCase().indexOf('smallsn') > -1
    },
    noPlayingLabels(){
      return this.$store.state.common['NEW_NO_PLAY_LABLE']
    }
  },
  watch: {
    timtRange (v) {
      if (v == 0) this.order.timeSlots = []
    },
    labelListPayway (v) {
      if (v && v[0]) {
        this.chargeWayName = ChargeWayEnum[v[0]] || 'cpd'
        this.chargeWayChange()
      }
    }
  },
  async created () {
    // 单次曝光 选择数据字典
    this.contentTimes = await this.getContentTimes()
    this.initContentTime()
    if (this.isSmallSn) {
      this.order.displayRegion = 2
    }
  },
  methods: {
    changeChargeWay (type, res) {
      let opt = this.order
      if (type === 'putscheme') {
        this.labelListPayway = res
        delete opt.clienteleName
        delete opt.choosePkg
        delete opt.packageInfoCodes
        delete opt.customerId
        delete opt.userId
      } else if (type === 'user') {
        let { customerId, customerName, id } = res
        opt.customerId = customerId || ''
        opt.clienteleName = customerName || ''
        opt.userId = id || ''
        opt.choosePkg = {}
        opt.packageInfoCodes = []
      } else if (type === 'pkg') {
        let { data, num } = res
        opt.choosePkg = data
        opt.choosePkg.num = num
        opt.packageInfoCodes = data.packageInfoCodes.slice(0, num)
        opt.pkgChooseFlow = num * (data.reachPersons || 0) // 选择套餐码对应的人流数量
      } else if (type === 'adtype') {
        opt.advertType = res[0]
      }
    },
    labelDataChange (data, type) {
      this.order.labelDataChangeType = type == 'profile' ? '' : type
      if (type == 'indus') { // 我的行业
        let codes = []
        data.forEach(el => {
          codes = codes.concat(el.chooses.map(ele => ele.code))
        })
        this.order.industryCodes = codes
        this.commonLabelData = []
        this.order.originPerson = []
        this.order.personsLabels = []
      } else { // 自定义标签
        if (type == 'common') {
          this.commonLabelData = data
        } else if (type == 'profile') { // 用户画像
          this.profileChange(data)
        }
        this.order.industryCodes = []
      }
    },
    reset () {
      if (!this.isSmallSn) this.initChargeWay()
      this.initContentTime()
      if (this.$refs.cityChoose) this.$refs.cityChoose.initHangZhou()
      this.order.startDate = new Date(+dateNow + 2 * dayMs).format().slice(0, 10)
      this.order.endDate = new Date(+dateNow + 8 * dayMs).format().slice(0, 10)
      this.initSearchTimeRange()
      this.order.contractNo = ''
      this.order.displayRegion = 1
      this.order.noPlayingLabels = []
      this.$refs.labelCmp.init()
    },
    initSearchTimeRange () {
      let timeRgRef = this.$refs.timeRangeRef
      if (timeRgRef) {
        timeRgRef.init()
      }
    },
    initChargeWay () {
      if (this.$refs.chargeWayRef) this.$refs.chargeWayRef.initOrReset()
    },
    initContentTime () {
      let dft = this.contentTimes.filter(el => el.default)[0] // 默认
      if (dft) { this.$set(this.order, 'contentTime', dft.dictItemName) }
    },
    timeConfirm (data) {
      let list = data.data || []
      this.timeStr = list.map(el => el.frequencyName).join('、')
      this.order.timeSegmentType = data.type
      this.searchTimeRange = list
    },
    chargeWayChange () { // 收费方式
      const cwn = this.chargeWayName
      if (cwn === 'cpd') { // cpd模式下 预算总额/目标流量 传 ''  endDate 传 ''
        this.order.targetFlowData = { targetFlowOrbudgetAmount: '', chooseLabel: [] }
      } else if (cwn === 'cpmL') {
        this.order.endDate = ''
      } else if (cwn === 'pkg') {
        // 选择【套餐兑换】后需将【展现位置】设置为主屏 lzd-20231221
        this.order.displayRegion = 1
        this.order.contractNo = ''
        delete this.order.contractNo
      }
      delete this.order.pkgChooseFlow // 删除选取套餐对应的流量数据传参
    },
    startDateChange (data) {
      if (this.order.endDate && new Date(data).getTime() > new Date(this.order.endDate).getTime()) {
        this.messageTip('结束时间须不能小于开始时间')
        this.order.endDate = ''
      }
    },
    endDateChange (data) {
      if (this.order.startDate && new Date(data).getTime() < new Date(this.order.startDate).getTime()) {
        this.messageTip('结束时间须不能小于开始时间')
        this.order.endDate = ''
      }
    },
    timeRangeChange (data) {
      this.order.timeSlots = data.map(el => el.guid)
      this.order.timeSlotsString = data.map(el => el.frequencyName)
    },
    getAddressCodes (data, initData) {
      // 改成只传所有选中的最顶层区域编码
      this.getAddressCodesFirst(data, initData)
    },
    getAddressCodesFirst (res, initData) {
      if (initData) {
        this.order.addressCodes = initData
        return
      }
      let addressCodesParam = this.rmCheckItemChilds(res)
      this.order.addressCodes = addressCodesParam.map(el => el.split('^^').join('.')).map(el => el.indexOf('.') < 0 ? el + '.' : el)
    },
    rmCheckItemChilds (res) { // 去除已选数据的子集数据：比如杭州市是选中状态，滨江区等区域选中的数据就不传参了
      let data = []
      let final = res.map(el => el.ids).sort()
      final.forEach(item => {
        data.forEach(el => {
          if ((item + '').indexOf(el) > -1) item = null
        })
        if (item) data.push(item + '')
      })
      return data
    },
    searchAction () {
      if (!this.testParams()) return
      this.$store.commit('order/setPayWay', this.chargeWayName)
      // 选取的用户标签 包括收费方式 等
      // reduce 虽然结果和第一个数据类型一致，可以不穿第三个参数空数组，但是最终会改变第一个数据，这里保持传第三个参数 保持不影响原本第一个数据
      // let labelParamList = Object.values(this.labelParam).reduce((res, cur) => res.concat(cur), [])
      let labelParamList = this.commonLabelData
      // 预算金额\目标流量对应的labelList传参
      let chargeType = this.labelListPayway[0]
      let targetLabel = this.order.targetFlowData.chooseLabel[0]
      let chargeTarget = targetLabel ? [ chargeType, targetLabel ] : (chargeType ? [ chargeType ] : [])
      // searchPointMix   mixin 里的方法  处理传参字段 condition, nbhdLabels(社区收入 社区类型), orderLabels(收费方式 预算 目标),
      let condition = this.handleLabelsParam(this.order, labelParamList, chargeTarget)

      let opt = JSON.parse(JSON.stringify(condition))
      opt.searchTimeRange = this.searchTimeRange
      this.$emit('submit', opt) // 深拷贝下 this.order 以免一些数据操作并未搜索 影响其他内容展示
      this.$store.commit('setStoreData', { key: 'conditionSearchCitys', value: this.$refs.cityChoose.$refs.tree.getCheckedNodes(false, true) })
      this.$store.commit('order/setForm', condition)
    },
    testParams () {
      let order = this.order
      let budget = order.budget ? order.budget.trim() : ''
      if (budget) {
        if (isNaN(budget)) return this.messageTip('广告预算须为数字', 2)
        else if (budget - 0 < 0) return this.messageTip('广告预算须大于0', 2)
      }

      if (!this.isSmallSn && !this.chargeWayName) return this.messageTip('请选择收费方式', 2) // 小屏投放无收费方式

      if (!this.isSmallSn && !this.order.advertType) return this.messageTip('请选择广告类型', 2)

      if (this.chargeWayName == 'pkg') {
        if (!order.userId) return this.messageTip('请选择客户/用户', 2) // 客户/用户数据 判断用户id就行 有用户 客户肯定有
        if (order.packageInfoCodes.length == 0) return this.messageTip('请选择套餐', 2) // 套餐码
        if (!order.clienteleName || order.clienteleName.trim() == '') return this.messageTip('请输入客户名称', 2)
      }

      let adsCodes = order.addressCodes
      if (!adsCodes || adsCodes.length == 0) {
        if (this.$refs.cityChoose && this.$refs.cityChoose.isWhole) {
          // order.addressCodes = [1] // 暂时全国传空数组
        } else {
          return this.messageTip('请选择投放城市', 2)
        }
      }
      // 套餐码兑换搜索 投放城市不能超过1个
      if (this.chargeWayName == 'pkg' && adsCodes.length > 1) {
        let cityArr = adsCodes.map(el => el.split('.')[0]) // 筛选出只有城市的code
        let onlyArr = cityArr.reduce((res, cur) => { // 去重
          if (res.indexOf(cur) === -1) res.push(cur)
          return res
        }, [])
        if (cityArr.length > onlyArr.length) return this.messageTip('套餐投放暂只能选择单个城市', 2)
      }

      if (!order.startDate) return this.messageTip('请选择投放开始日期', 2)

      if (this.chargeWayName != 'cpmL') { // cpm按流量模式无结束日期选项
        if (!order.endDate) return this.messageTip('请选择投放结束日期', 2)

        if (new Date(order.startDate).getTime() > new Date(order.endDate).getTime()) {
          return this.messageTip('结束日期须大于等于开始日期', 2)
        }
        if (new Date(order.endDate).getTime() - new Date(order.startDate).getTime() > 30 * dayMs) {
          return this.messageTip('时间范围须小于等于31天', 2)
        }
      }
      if (this.timtRange == 1) {
        if (!order.timeSlots || order.timeSlots.length == 0) return this.messageTip('请选择投放时间段', 2)
      }

      if (!this.isSmallSn) { // 小屏投放无收费方式以及相关输入
        let { chooseLabel, targetFlowOrbudgetAmount } = order.targetFlowData
        let flowNum = ((targetFlowOrbudgetAmount || '') + '').trim()
        if (this.chargeWayName == 'cpmL') {
          if (!flowNum) {
            if (chooseLabel.indexOf('M1') > -1) return this.messageTip('请填写触达总量后再查找电梯广告', 2)
            else if (chooseLabel.indexOf('M2') > -1) return this.messageTip('请填写精准流量后再查找电梯广告', 2)
          }
        } else if (this.chargeWayName == 'cpmT') {}
      }

      const adLong = (order.contentTime || '').trim()
      if (!adLong) return this.messageTip('请选择单次曝光', 2)

      if (this.chargeWayName !== 'pkg') {
        const contract = (order.contractNo || '').trim()
        if (!contract) return this.messageTip('请输入合同编码', 2)
        order.contractNo = contract
      }

      return true
    }
  }
}
</script>

<style lang="sass" scoped>
.time-area
  float: right
  width: 220px
  height: 28px
  line-height: 28px
  cursor: pointer
  .els
    width: 192px
    display: inline-block
  i
    margin-left: 4px
    margin-right: 10px
    margin-top: 9px
    color: #C0C4CC
    &.up
      transform: rotate(180deg)

.order_form_point
  padding: 20px
  height: 100%
  overflow: auto

  .form-ctn
    height: calc(100% - 70px)
    overflow-x: hidden
    overflow-y: auto

  .custom
    .el-input
      font-size: 12px
      padding-right: 25px

  ::v-deep .el-form
    .el-form-item
      margin-bottom: 20px
      box-shadow: 0 0 0 1px #e9e9e9 inset
      border-radius: 4px
      padding: 5px 0 5px 19px
      .el-form-item__label
        color: #282729
        font-weight: 600
        border-right: 1px solid #e9e9e9
        padding: 0
        margin-top: 5px
        line-height: 20px
        width: 68px
        text-align: left

    .el-form-item__content
      .el-select
        .el-select__tags
          padding-left: 10px
    .icon-biaodan-shijian
      color: #c0c4cc
      margin-right: 10px

    > .el-input
      font-size: 12px

    .el-select, .el-input
      width: 220px
      &.input-date
        width: 86px
        padding-left: 0
        margin-right: 5px
        > input
          padding-left: 10px
      input
        border: none
        color: #282729
        padding-right: 0
        padding-left: 10px
        &:focus
          border-bottom: none !important
      .el-input__prefix
        display: none

    .el-select .el-tag
      margin: 2px 2px 2px 0

  .el-input--mini
    font-size: 14px

.time
  position: relative
  span.tip
    color: #999
    font-size: 12px
    position: absolute
    left: 68px
    bottom: -30px

.btm
  border-top: 1px solid #E9E9E9
  padding: 0  20px
  position: absolute
  bottom: 0
  width: 100%
  margin: 0 -20px
  text-align: center
  .btn
    width: 150px
    line-height: 40px
    font-weight: 400
    text-align: center
    color: #282729
    cursor: pointer
    margin: 15px 0
    border: 1px solid #D4D4D4
    border-radius: 4px
    display: inline-block
    &.search
      background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%)
      color: #fff
      margin-right: 20px
      border: 0

</style>
